import { render, staticRenderFns } from "./GoToSignup.vue?vue&type=template&id=43a141a3&"
import script from "./GoToSignup.vue?vue&type=script&lang=js&"
export * from "./GoToSignup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports